import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class ColorStore {

  @setter @observable r;
  @setter @observable g;
  @setter @observable b;
  @setter @observable a;

  static create(data={}) {
    const instance = new ColorStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "r": null,
      "g": null,
      "b": null,
      "a": null,
    };
  }

  constructor(defaults=ColorStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ColorStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "r"},
      {"field": "g"},
      {"field": "b"},
      {"field": "a"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  serialize() {
    return {
      'r': this.r,
      'g': this.g,
      'b': this.b,
      'a': this.a,
    }
  }

  get rgba() {
    return this.serialize();
  }

  get css() {
    if ([null, ""].includes(this.r)) return "transparent";
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
  }
}


export default ColorStore;
